(() => {
  const formatFallback = (value) => value || '';

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mc-variant-select]');
    if (!select) return;

    const root = select.closest('[data-mc-product-root]');
    const option = select.options[select.selectedIndex];
    if (!root || !option) return;

    root.querySelectorAll('[data-mc-price]').forEach((el) => {
      el.textContent = formatFallback(option.dataset.price);
    });

    root.querySelectorAll('[data-mc-compare]').forEach((el) => {
      const compare = option.dataset.compare || '';
      el.textContent = compare;
      el.hidden = !compare || compare === option.dataset.price;
    });

    const available = option.dataset.available === 'true';
    root.querySelectorAll('[data-mc-atc]').forEach((button) => {
      button.disabled = !available;
      button.textContent = available
        ? (button.dataset.availableText || 'Add To Cart')
        : (button.dataset.soldoutText || 'Sold Out');
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-mc-product-form]');
    if (!form) return;
    const button = form.querySelector('[data-mc-atc]');
    if (!button || button.disabled) return;
    button.dataset.originalText = button.textContent;
    button.textContent = button.dataset.loadingText || 'Adding...';
    button.disabled = true;
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-mc-atc]').forEach((button) => {
      if (button.dataset.originalText) {
        button.textContent = button.dataset.originalText;
        button.disabled = false;
      }
    });
  });
})();
